<template lang="html">
  <div class="detail">
    <!-- <h3 class="detail-title">星圈</h3> -->
    <div class="content">
      <DynamicItem  @updateItem="updateItem" :visible_range="visible_range" :upCount="upCount" :screen_style="screen_style" :is_actual="is_actual" :post_type="post_type" :isUp="isUp" :downCount="downCount" :isDown="isDown" :tags="tags" :commentCount="commentCount" :id="id" :user="user" :images="images" :crateTime="createTime" :content="content" :expandProps= true />
        <button @click="goCreate" v-if="messages.length === 0" class="emptyWrite">写留言</button>
        <template v-else>
          <div class="message">
            <h3>{{messages.length}}条留言</h3>
            <DynamicMessage v-for="item of messages" @deleteMessage="deleteMessage" @thumbsUp="childthumbsUp(item)" :visible_range="visible_range" :key="item.id" v-bind="item" />
          </div>
        </template>
    </div>
    <div class="footer" v-if="messages.length !== 0">
      <!-- <button class="button" @click="goHome"><img src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home1.svg"/>首页</button> -->
      <button @click="goCreate" class="write" type="text"><span class="icon iconfont">&#xe68c;</span>写留言</button>
    </div>
    <Suspension @share="getShareContent"/>
    <!-- <Suspension v-if="platform !== 'notInDingTalk'" @share="getShareContent"/> -->
    <Suspension bottom="36px" desc="回首页" img="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/home.svg" @share="goHome"/>
    <!-- <Suspension bottom="200px" desc="回首页" img="http://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-wechat/resource/image/图标0704230704174611.jpg" @share="goHome"/> -->
  </div>
</template>
<script>
import { isAndroid } from '../../../utils/utils'
import DynamicItem from '../../../components/DynamicItem'
import DynamicMessage from '../../../components/DynamicMessage'
import { get } from '../../../utils/request'
import DDMixis from '../../../minixs/ddMixis'
import { get as getUser } from '../../../utils/token'
import { goHomePath } from '../../../utils/power'
// import dd from 'DD'
export default {
  mixins: [DDMixis],
  components: {
    DynamicItem,
    DynamicMessage
  },
  // activated () {
  //   const { nickName, id, userId } = this.$route.params
  //   this.id = id
  //   this.user.nickName = nickName
  //   this.user.id = userId
  //   this.getDynamicDetails(id)
  //   this.getDynamicMessage(id)
  // },
  mounted () {
    const { nickName, id, userId } = this.$route.params
    this.id = id
    this.user.nickName = nickName
    this.user.id = userId
    this.getDynamicDetails(id)
    this.getDynamicMessage(id)
  },
  data () {
    return {
      isAndroid: isAndroid(),
      platform: dd.env.platform,
      safeHeight: 0,
      id: 1,
      isUp: false,
      isDown: false,
      user: {
        id: '',
        nickName: '',
        avatar: ''
      },
      createTime: '',
      upCount: 0,
      downCount: 0,
      content: '',
      commentCount: 111,
      images: [],
      messages: [],
      tags: [],
      is_actual: '',
      post_type: '',
      screen_style: '',
      visible_range: ''
    }
  },
  methods: {
    goHome () {
      this.$router.push({
        path: goHomePath()
      })
    },
    updateItem (reload) {
      Object.assign(this, reload)
    },
    childthumbsUp (item) {
      item.isUp = !item.isUp
      let count = item.upCount
      if (item.isUp) {
        ++count
      } else {
        --count
      }
      item.upCount = count
    },
    deleteMessage () {
      const { id } = this.$route.params
      this.getDynamicMessage(id)
    },
    upUvdata (id) {
      const user = getUser('user')
      const obj = {
        user: user.id,
        path: `/exerland/dynamicTetail/${id}`,
        location: `话题详情-${id}`,
        tracking_type: 4
      }
      if (this.visible_range === 'oversea') {
        obj.location = `HR知乎详情-${id}`
        obj.tracking_type = 7
      }
      this.$API.upUvData(obj)
    },
    getDynamicDetails (id) {
      const user = getUser('user')
      const promise = get({
        url: `/circle/detail/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
          this.upUvdata(id)
        }
      })
    },
    getDynamicMessage (id) {
      const user = getUser('user')
      const promise = get({
        url: `/circle/commentTree/${id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          this.messages = detail
        }
      })
    },
    goCreate () {
      const { id } = this
      this.$router.push({
        path: '/exerland/create',
        query: {
          circleId: id,
          mobile: this.user.username,
          isAnonymous: !this.is_actual,
          visible_range: this.visible_range
        }
      })
    }
  },
  computed: {
    getTarbarAuth () {
      return this.$store.getters['tarbarAuth/getAuth']
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/font/iconfont.css";
.detail {
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  .content {
     overflow-y: scroll;
     height: calc(100% - 40px);
     /deep/ .desc {
       display: block;
     }
     .detail-title {
      font-size: 17px;
      font-family: SFProText-Semibold, SFProText;
      font-weight: 600;
      color: rgba(0, 0, 0, 1);
      line-height: 22px;
      text-align: center;
      padding: 13px 4.27vw;
      overflow: scroll;
    }
    .emptyWrite {
      display: inherit;
      width: 132px;
      height: 44px;
      background: rgba(245, 245, 245, 1);
      border-radius: 4px;
      font-size: 17px;
      border: none;
      margin: 85px auto 0;
    }
    .message {
      h3 {
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
        padding: 13px 4.27vw;
      }
    }
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 40px;
    background: #fff;
    z-index: 9;
    box-sizing: border-box;
    display: flex;
    // line-height: 40px;
    border-top: 1px solid #f5f5f5;
    .write {
      width: 100%;
      color: rgba(51, 51, 51, 1);
      font-size: 17px;
      .icon {
        margin-right: 4px;
      }
    }
    .button {
        width:128px;
        height:40px;
        background:rgba(24,204,159,1);
        box-shadow:0px 4px 12px 0px rgba(0,0,0,0.08);
        border-radius:22px;
        font-size:16px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:16px;
        text-shadow:0px 4px 12px rgba(0,0,0,0.08);
        border: none;
        box-sizing: border-box;
        img {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-right: 16px;
        }
      }
  }
}
/deep/ .content-item {
  border: none;
  .content-bottom {
    justify-content: flex-end;
  }
}
button {
      border: none;
      outline: none;
      background: #fff;
      height: 40px;
    }
</style>
